  /**
   * 予約購入ボタン・販売プラン切替（Dawn 7系向け・在庫判定つき）
   *
   * 対象: タグ「PreOrder」あり かつ 在庫追跡ON かつ 在庫0 かつ 購入可（Continue selling ON）
   *  - カートボタンの文言を「Pre-order」に変更
   *  - selling_plan の hidden input を有効化（非予約バリアントでは disabled）
   *
   * Dawn 7 には pubsub.js が無く、global.js の VariantSelects/VariantRadios が
   * バリアント切替のたびに toggleAddButton() で文言を戻す（Section Rendering の
   * fetch 完了後＝非同期）ため、MutationObserver でボタンを監視して上書きする。
   * selling_plan の切替は updateVariantInput() が発行する change イベントで即時反映。
   */
  (() => {
    const DATA_PREFIX = 'PreorderData-';

    const getData = (sectionId) => {
      const el = document.getElementById(DATA_PREFIX + sectionId);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    };

    const apply = (sectionId) => {
      const data = getData(sectionId);
      if (!data) return;

      const form = document.getElementById(`product-form-${sectionId}`);
      if (!form) return;

      const idInput = form.querySelector('input[name="id"]');
      const variantId = idInput ? idInput.value : null;
      const isPreorder = Boolean(variantId && data.variants && data.variants[String(variantId)]);

      // selling_plan の有効/無効を切り替え（disabled な input は送信されない）
      const planInput = document.getElementById(`PreorderSellingPlan-${sectionId}`);
      if (planInput) planInput.disabled = !isPreorder;

      // 予約時のみ body にクラスを付ける（Liquid 側の CSS がこれを前提にしている）
      document.body.classList.toggle('rcmr-preorder', isPreorder);

      // ボタン文言（売り切れ等で disabled のときはテーマの表示を尊重）
      const button = form.querySelector('[name="add"]');
      if (!button || button.hasAttribute('disabled')) return;
      const label = button.querySelector('span') || button;
      // 同値なら書き込まない（MutationObserver の無限ループ防止）
      if (isPreorder && label.textContent.trim() !== data.buttonText) {
        label.textContent = data.buttonText;
      }
    };

    const init = () => {
      document.querySelectorAll(`script[id^="${DATA_PREFIX}"]`).forEach((el) => {
        const sectionId = el.id.slice(DATA_PREFIX.length);
        apply(sectionId);

        const form = document.getElementById(`product-form-${sectionId}`);
        if (!form) return;

        // バリアント切替直後に selling_plan を即時切替
        // （global.js の updateVariantInput が input[name="id"] に change を発行する）
        form.addEventListener('change', () => apply(sectionId));

        const button = form.querySelector('[name="add"]');
        if (!button) return;

        // テーマ（toggleAddButton）や Globo 等アプリによる文言リセットに追従
        new MutationObserver(() => apply(sectionId)).observe(button, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled'],
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();